import { type TranslationTree } from '@/i18n/types';

export const messages = {
  loadError: 'Não foi possível carregar o evento',
} satisfies TranslationTree;
